import { useEffect, useRef, useState } from "react";
import FormGroup from "./FormGroup";

export type TValidator<T> = (value:T|undefined|null) => string|null
export type TValidators<T> = TValidator<T>[]

export interface IValidator {
    valid:boolean;
    dirty:boolean;
}

function isNumber(val:any) : val is number {
    return typeof(val)=="number" || !isNaN(parseFloat(val))
}

export default class Validators {
    static Required(value:any) { return value ? null : "Required"}
    static Email(value:any){ return /^[^@\/]+@[^.@\/]+\.[^@\/]+$/.test(value) ? null : "Invalid E-mail" }
    static PositiveNumber(value:any) { return isNumber(value) && value>0 ? null : "Must be a positive number"}
    static GreaterOrEqualZero(value:any) { return isNumber(value) && value>=0 ? null : "Must be greater than or equal to 0"}
    static NonZero(value:any) {         return isNumber(value) && (value>0||value<0) ? null : "Must be non-zero number" }
    static Number(value:any) { return isNumber(value) ? null : "Must be number" }
}

export interface IFormFieldProps<T> {
    controlName?:string;
    form?:FormGroup;
    defaultValue?:any
    value?:any
}

export function useValidator<T>(props:IFormFieldProps<T>){
    const form = props.form
    const control = props.controlName ? form?.control(props.controlName) : null
    const mounted = useRef<boolean>(false)

    const [error,setError] = useState<string|null>(control?.dirty ? control?.error : null)

    const onRefresh = () => control?.dirty ? setError(control.error) : null

    useEffect(() => {
        control?.on("refresh", onRefresh);
        (props.value || props.defaultValue) && control?.update(props.value || props.defaultValue)
        return () => {control?.removeListener("refresh", onRefresh)}
    },[])

    useEffect(() => {
        if (mounted.current) control?.update(props.value)
        else mounted.current = true
    }, [props.value])

    return {error, form, control}
}

